/** @format */

import { useEffect, useRef } from "react";

const VideoPlayer = ({ src }) => {
  const videoRef = useRef(null);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.play().catch(() => {});
    }
  }, [src]);

  return (
    <div className='relative w-full rounded-2xl overflow-hidden shadow-lg bg-black group'>
      <video
        ref={videoRef}
        src={src}
        controls
        autoPlay
        playsInline
        muted
        loop
        preload='auto'
        className='w-full max-h-[460px] object-contain'
      />
      {/* Subtle gradient overlay at top for pro look */}
      <div className='absolute inset-x-0 top-0 h-8 bg-gradient-to-b from-black/30 to-transparent pointer-events-none' />
    </div>
  );
};

export default VideoPlayer;
